import React from 'react';

import { BodyText, BodyTextSmall, FlexCol } from '@minecraft.atoms';
import { TalentScoutProfileFragment } from '@minecraft.graphql-operations';
import { useTranslation } from '@blocs.i18n';

// Pitch notes have a max length of 200 chars, but this will add additional guards.
const trimPitchNotes = (text: string) => (text.length > 200 ? text.slice(0, 200).concat('...') : text);

export const PitchNotes: React.FC<Pick<TalentScoutProfileFragment, 'noteToRepresentative'>> = ({
  noteToRepresentative,
}) => {
  const { t } = useTranslation();
  const pitchNotes = noteToRepresentative ? trimPitchNotes(noteToRepresentative) : undefined;

  return (
    <FlexCol gap="1" data-testid="pitch-notes-wrap">
      <BodyText fontWeight="medium">{t('reps:talentScout.pitchNotes')}</BodyText>
      {pitchNotes?.length > 0 ? (
        <BodyTextSmall testId="pitchnotes-text">{pitchNotes}</BodyTextSmall>
      ) : (
        <BodyTextSmall italic color="disabled" testId="pitchnotes-placeholder">
          {t('reps:talentScout.noPitchNotes')}
        </BodyTextSmall>
      )}
    </FlexCol>
  );
};
